export default "__VITE_ASSET__3ZAcbxl5__"